import React from 'react';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcFinishContact from 'components/molecules/PcFinishContact';

import { THANKS_TEXT } from 'utils/constant';

const PresentPC = ({
  onClickMainButton,
}) => (
  <div className="Thanks">
    <PcBasicTemplate 
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={true}
      >
    <span>
      <PcFinishContact
        info={THANKS_TEXT.information}
      />
    </span>
    </PcBasicTemplate>
  </div>
);
  

export default PresentPC;